<onsip-animation filename="error_cropped"></onsip-animation>
<h2 mat-dialog-title>{{ "ONSIP_I18N.UHOH" | translate }}</h2>
<div mat-dialog-content>
  <p>{{ "ONSIP_I18N.WE_JUST_ENCOUNTERED_SOMETHING_ODD" | translate }}</p>
  <mat-divider onsip-dotted-divider></mat-divider>
  <p>{{ "ONSIP_I18N.PLEASE_REFRESH_THE_PAGE_TO_CONTINUE" | translate }}</p>
</div>
